import {
  Burger,
  Toggle,
} from "@/components/ui";
import useLadyService from "@/services/LadyService";
import {
  BurgerMenu,
  DropdownLanguage,
  HeaderTabs,
  Logo,
  MenuNavBar,
  UserWrapperDesktop
} from "../components";

import "../header.scss";

const ModerOrAdminLK = () => {
  const { windowWidth, } = useLadyService();

  if (windowWidth > 1199.98)
    return (
      <>
        <div className="header__top">
          <DropdownLanguage />

          <Toggle type={"theme"} id={'theme-main-toggle'} />
        </div>

        <div className="header__bottom">
          <Logo />

          <div className={"header__tabs"}>
            <HeaderTabs lk />
          </div>

          <UserWrapperDesktop lk />
        </div>
      </>
    );

  if (windowWidth > 767.98)
    return (
      <div className="header__top">
        <Logo />

        <div className="user__wrapper">

          <Burger />

          <DropdownLanguage size={"s"} />

          <Toggle type={"theme"} id={'theme-main-toggle'} />

          <BurgerMenu lk />
        </div>
      </div>
    );

  return (
    <>
      <div className="header__top">
        <div className="user__wrapper">
          <Toggle type={"theme"} id={'theme-main-toggle'} />
        </div>

        <Logo />

        <div className="user__wrapper">
          <DropdownLanguage />
          <Burger />
        </div>


        <BurgerMenu lk />

        <MenuNavBar lk />
      </div>
    </>
  );
};
export default ModerOrAdminLK;